var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h4', {
    staticClass: "mb-3 font-weight-bold"
  }, [_vm._v("核銷頁")]), _vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "disabled": _vm.isReadOnly
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" Banner "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": ".75rem"
          }
        }, [_vm._v("寬 x 高：1400px x 700px")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_vm.selectedImage ? _c('li', {
          staticClass: "s-image-list-item s-draggable"
        }, [_c('img', {
          staticClass: "s-cropped-image",
          attrs: {
            "src": _vm.selectedImage
          }
        }), _c('button', {
          staticClass: "btn btn-danger s-delete-btn",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.selectedImage = null;
            }
          }
        }, [_vm._v(" Ｘ ")])]) : _c('li', {
          staticClass: "s-image-list-item"
        }, [_c('ImageSelector', {
          attrs: {
            "aspect-ratio": 1400 / 700
          },
          on: {
            "input": function input(croppedImage) {
              return _vm.selectedImage = croppedImage;
            }
          },
          scopedSlots: _vm._u([{
            key: "trigger",
            fn: function fn(_ref) {
              var openFileSelector = _ref.openFileSelector;
              return [_c('button', {
                staticClass: "btn s-trigger-btn",
                on: {
                  "click": openFileSelector
                }
              }, [_vm._v(" ＋ 加入照片 ")])];
            }
          }])
        })], 1)];
      },
      proxy: true
    }])
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "標題",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.deepGet(_vm.v$, 'form.config.confirm_page.form_title.$error') ? false : null
    },
    model: {
      value: _vm.form.config.confirm_page.form_title,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.confirm_page, "form_title", $$v);
      },
      expression: "form.config.confirm_page.form_title"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.confirm_page.form_title.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "副標題",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.deepGet(_vm.v$, 'form.config.confirm_page.form_desc.$error') ? false : null
    },
    model: {
      value: _vm.form.config.confirm_page.form_desc,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.confirm_page, "form_desc", $$v);
      },
      expression: "form.config.confirm_page.form_desc"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.confirm_page.form_desc.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "內容說明",
      "disabled": _vm.isReadOnly
    }
  }, [_c('TrixEditor', {
    attrs: {
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.config.confirm_page.content,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.confirm_page, "content", $$v);
      },
      expression: "form.config.confirm_page.content"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.confirm_page.content.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "核銷設定"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.confirmTypes,
      "state": _vm.v$.form.config.confirm_page.confirm_type.$error ? false : null,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.form.config.confirm_page.confirm_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.confirm_page, "confirm_type", $$v);
      },
      expression: "form.config.confirm_page.confirm_type"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.config.confirm_page.confirm_type.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "核銷期限"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "disabled": _vm.isReadOnly,
      "value": "by_form"
    },
    model: {
      value: _vm.form.config.confirm_page.period_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.confirm_page, "period_type", $$v);
      },
      expression: "form.config.confirm_page.period_type"
    }
  }, [_vm._v(" 與表單期限相同 ")])], 1), _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('b-form-radio', {
    staticClass: "mr-2",
    attrs: {
      "disabled": _vm.isReadOnly,
      "value": "custom"
    },
    model: {
      value: _vm.form.config.confirm_page.period_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.confirm_page, "period_type", $$v);
      },
      expression: "form.config.confirm_page.period_type"
    }
  }, [_vm._v(" 自訂期限 ")]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "language": _vm.zh,
      "format": "yyyy-MM-dd",
      "disabled": _vm.isReadOnly || _vm.form.config.confirm_page.period_type !== 'custom',
      "clear-button": !_vm.isReadOnly,
      "input-class": _vm.deepGet(_vm.v$, 'form.config.confirm_page.period_start_at.$error') ? 'is-invalid' : ''
    },
    model: {
      value: _vm.form.config.confirm_page.period_start_at,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.confirm_page, "period_start_at", $$v);
      },
      expression: "form.config.confirm_page.period_start_at"
    }
  }), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "language": _vm.zh,
      "format": "yyyy-MM-dd",
      "disabled": _vm.isReadOnly || _vm.form.config.confirm_page.period_type !== 'custom',
      "clear-button": !_vm.isReadOnly,
      "input-class": _vm.deepGet(_vm.v$, 'form.config.confirm_page.period_end_at.$error') ? 'is-invalid' : ''
    },
    model: {
      value: _vm.form.config.confirm_page.period_end_at,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.confirm_page, "period_end_at", $$v);
      },
      expression: "form.config.confirm_page.period_end_at"
    }
  })], 1)], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.config.confirm_page.period_type.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), !_vm.isReadOnly ? _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submitPage
    }
  }, [_vm._v(" 儲存 ")])], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }